import { render, staticRenderFns } from "./ShipMonitor.vue?vue&type=template&id=2ebe7639&scoped=true"
import script from "./ShipMonitor.vue?vue&type=script&lang=js"
export * from "./ShipMonitor.vue?vue&type=script&lang=js"
import style0 from "./ShipMonitor.vue?vue&type=style&index=0&id=2ebe7639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe7639",
  null
  
)

export default component.exports